export function fmtTime(sec) {
  if (!Number.isFinite(sec) || sec < 0) sec = 0;
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  const pad = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

export function fmtRuntime(min) {
  if (!min) return "";
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h ? `${h}h ${String(m).padStart(2, "0")}m` : `${m}m`;
}

export function fmtDuration(sec) {
  const m = Math.max(1, Math.round(sec / 60));
  return m >= 60 ? fmtRuntime(m) : `${m}m`;
}

export function fmtRemaining(sec) {
  const m = Math.max(1, Math.round(sec / 60));
  return `${m >= 60 ? fmtRuntime(m) : `${m}m`} left`;
}

export function titleMeta(t) {
  if (!t) return "";
  const length = t.type === "series" ? `${t.seasons_count ?? t.seasons?.length ?? 0} Season${(t.seasons_count ?? t.seasons?.length) === 1 ? "" : "s"}` : fmtRuntime(t.runtime_min);
  return [t.year, t.maturity_rating, length].filter(Boolean).join(" · ");
}

export const TYPE_LABEL = { movie: "Film", series: "Series", short: "Short" };
